import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the ViewordinePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare let sunmiInnerPrinter: any;
@IonicPage()
@Component({
  selector: 'page-viewordine',
  templateUrl: 'viewordine.html',
})
export class ViewordinePage {
  public ordineItem;
  info: any;
  ordineItems: any;
  ordineMenu: any;
  errorMessage: string;
  valutazione;
  orariConsegna;
  cat = "order";
  constructor(public navCtrl: NavController, public navParams: NavParams, public rest: RestApiProvider,
    private alertCtrl: AlertController,

  ) {
    this.ordineItem = navParams.get('ordine');


  }
  ionViewWillEnter() {
    this.getInfoRistorante();
    this.getOrdineItemList();
    this.getOrdineMenu();
    this.getValutazione();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewordinePage');
    this.getOrariConsegna();
  }
  getValutazione() {
    this.rest.getValutazione(this.ordineItem.id).subscribe(
      valutazione => {
        // alert(valutazione);
        if (valutazione != null && valutazione != undefined && valutazione.id > 0) {
          this.valutazione = valutazione;


        }
      },
      error => this.errorMessage = <any>error);
  }
  getInfoRistorante() {
    this.rest.getInfoRistorante()
      .subscribe(
        info => this.info = info,
        error => this.errorMessage = <any>error);

    console.log("infoRistorante:" + JSON.stringify(this.info));
  }
  getOrdineItemList() {
    //  console.log("getOrdineItemList.......................................:"+JSON.stringify(this.ordineItem));
    this.rest.getOrdineItemList(this.ordineItem.id)
      .subscribe(
        ordineItems => this.ordineItems = ordineItems,
        error => this.errorMessage = <any>error);

    console.log("infoRistorante:" + JSON.stringify(this.info));
  } .0
  getOrdineMenu() {
    this.rest.getOrdineMenu(this.ordineItem.id).subscribe(
      ordineMenu => this.ordineMenu = ordineMenu,
      error => this.errorMessage = <any>error);
  }
  getOrariConsegna() {
    // alert("ordine ID:" + this.ordineId)
    if (this.ordineItem.consegnaPrevisto == null) {
      this.rest.getOrarioList(this.ordineItem.id)
        .subscribe(
          orariConsegna => this.orariConsegna = orariConsegna,
          error => this.errorMessage = <any>error);
    }
  }
  Accettata() {

    let alert = this.alertCtrl.create({
      title: "Cambia stato ordine",
      subTitle: "Scegli nuovo stato ordine:",
      enableBackdropDismiss: false, // <- Here! :)
      buttons: [
        {
          text: ' Annullata  ',
          role: 'cancel',

          handler: () => {
            console.log('Cancel clicked');
          //  this.ordineItem.stato = 3; //riufiutato
          //  this.rest.invioUpdateOrdine(this.ordineItem);

          },

        },
        {
          text: '   Accettata   ',
          handler: data => {

            console.log('OK clicked. Data -> ' + JSON.stringify(data));
           // this.ordineItem.consegnaPrevisto = this.orariConsegna[data].orario;
           if(this.ordineItem.consegnaPrevisto==null){
            this.ordineItem.stato = 0;// in attessa

           }else{
            this.ordineItem.stato = 2;// accettato
            this.rest.invioUpdateOrdine(this.ordineItem);
           }
          
            // this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);

          }
        }
      ]
    });

    alert.present();

  }
  Annullata() {

    let alert = this.alertCtrl.create({
      title: "Cambia stato ordine",
      subTitle: "Scegli nuovo stato ordine:",
      enableBackdropDismiss: false, // <- Here! :)
      buttons: [
        {
          text: ' Annullata  ',
          role: 'cancel',

          handler: () => {
            console.log('Cancel clicked');
            this.ordineItem.stato = 3; //riufiutato
            this.rest.invioUpdateOrdine(this.ordineItem);

          },

        },
        {
          text: '   Accettata   ',
          handler: data => {

            console.log('OK clicked. Data -> ' + JSON.stringify(data));
           // this.ordineItem.consegnaPrevisto = this.orariConsegna[data].orario;
           // this.ordineItem.stato = 2;// accettato
           // this.rest.invioUpdateOrdine(this.ordineItem);
            // this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);

          }
        }
      ]
    });

    alert.present();

  }
  scegliOrarioPrevisto() {
    let titolo;
    if (this.ordineItem.address != null) {
      titolo = "CONSEGNA"

    } else {
      titolo = "RITIRO"
    }
    let alert = this.alertCtrl.create({
      title: titolo,
      subTitle: "Nuovo ordine:" + this.ordineItem.id + ", seleziona orario",
      enableBackdropDismiss: false, // <- Here! :)
      buttons: [
        {
          text: 'Rifiuta ',
          role: 'cancel',

          handler: () => {
            console.log('Cancel clicked');
            this.ordineItem.stato = 3; //riufiutato
            this.rest.invioUpdateOrdine(this.ordineItem);

          },

        },
        {
          text: '   Accetta ordine   ',
          handler: data => {

            console.log('OK clicked. Data -> ' + JSON.stringify(data));
            this.ordineItem.consegnaPrevisto = this.orariConsegna[data].orario;
            this.ordineItem.stato = 2;// accettato
            this.rest.invioUpdateOrdine(this.ordineItem);
            // this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);

          }
        }
      ]
    });
    var i;
    for (i = 0; i < this.orariConsegna.length; i++) {

      alert.addInput({
        type: 'radio',
        label: this.orariConsegna[i].orario,
        checked: this.orariConsegna[i].selezionato,
        value: i
      })



    }

    alert.present();

  }
  async ordineItemStampa() {

    await sunmiInnerPrinter.printerInit();
    // await sunmiInnerPrinter.printOriginalText(" \n");
    await sunmiInnerPrinter.setAlignment(1);// align center
    await sunmiInnerPrinter.printTextWithFont(this.info.nameStore + '\n', 'gh', 35)

    await sunmiInnerPrinter.printTextWithFont("Tel." + this.info.fixNumber + '\n', 'gh', 30)

    await sunmiInnerPrinter.printTextWithFont(" \n", 'gh', 22)


    await sunmiInnerPrinter.setAlignment(0);// align left

    await sunmiInnerPrinter.setFontSize(30);
    //await sunmiInnerPrinter.printTextWithFont("Codice ordine:" + this.ordineItem.id, 'gh', 30)

    await sunmiInnerPrinter.setFontSize(30)
    var colsWidthArr = [15, 10];

    var colsTextArr = ["Codice ordine", this.ordineItem.id];
    var colsAlign = [0, 2];

    await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);

    //await sunmiInnerPrinter.printOriginalText("\n");
    //sconto

   

    if (this.ordineItem.address != null) {
      // await sunmiInnerPrinter.printTextWithFont("Consegna ore:" + this.ordineItem.orario, 'gh', 30)
      await sunmiInnerPrinter.setFontSize(30)
      var colsWidthArr = [15, 10];
      this.ordineItem.orario = this.ordineItem.orario.substring(0, this.ordineItem.orario.length - 3);
      var colsTextArr = ["Ore consegna", this.ordineItem.orario];
      var colsAlign = [0, 2];

      await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);

    } else {
      // await sunmiInnerPrinter.printTextWithFont("Ritiro ore:" + this.ordineItem.orario, 'gh', 30)
      await sunmiInnerPrinter.setFontSize(30)
      var colsWidthArr = [15, 10];
      this.ordineItem.orario = this.ordineItem.orario.substring(0, this.ordineItem.orario.length - 3);
      var colsTextArr = ["Ore ritiro", this.ordineItem.orario];
      var colsAlign = [0, 2];

      await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);


    }

     //codice cliente
     await sunmiInnerPrinter.setFontSize(30)
     var colsWidthArr = [15, 10];
 
     var colsTextArr = ["Codice cliente", this.ordineItem.usercliente.codice];
     var colsAlign = [0, 2];
 
     await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
 
   //pagato
     if (this.ordineItem.pagato == true) {
       
       await sunmiInnerPrinter.setAlignment(1);// align center
 
       await sunmiInnerPrinter.printTextWithFont("**** PAGATO ****" + '\n', 'gh', 35)
     }
 
    await sunmiInnerPrinter.printTextWithFont(" \n", 'gh', 22)

    await sunmiInnerPrinter.setAlignment(0);// align left

    if (this.ordineItem.address != null) {
      await sunmiInnerPrinter.printTextWithFont("Indirizzo consegna:\n", 'gh', 35)



      var indirizzo = this.ordineItem.address.street + "," + this.ordineItem.address.civicNumber + "," + this.ordineItem.address.name + ",";


      if (this.ordineItem.address.intercom != null)
        indirizzo = indirizzo + "Interno:" + this.ordineItem.address.intercom + ",";
      if (this.ordineItem.address.building != null)
        indirizzo = indirizzo + "Palazzo/Scala:" + this.ordineItem.address.building + ",";
      indirizzo = indirizzo + this.ordineItem.address.cap + " " + this.ordineItem.address.city
      await sunmiInnerPrinter.printTextWithFont(indirizzo + '\n', 'gh', 30)



    } else {

      //    await sunmiInnerPrinter.printTextWithFont('Ritiro al negozio\n', 'gh', 30);

    }

    //await sunmiInnerPrinter.printOriginalText("\n");

    await sunmiInnerPrinter.printTextWithFont('-------------------------', 'gh', 30)

    await sunmiInnerPrinter.printOriginalText("\n");




    //stampa menu
    var j;

    for (j = 0; j < this.ordineMenu.length; j++) {
      if (this.ordineMenu[j].codice != null && this.ordineMenu[j].codice != "")
        await sunmiInnerPrinter.printTextWithFont("#" + this.ordineMenu[j].quantita + "x" + this.ordineMenu[j].codice + " " + this.ordineMenu[j].nome + '\n', 'gh', 23)
      else
        await sunmiInnerPrinter.printTextWithFont("#" + this.ordineMenu[j].quantita + "x" + this.ordineMenu[j].nome + '\n', 'gh', 26)

      var z;
      for (z = 0; z < this.ordineMenu[j].omil.length; z++) {
        await sunmiInnerPrinter.printTextWithFont("  >" + this.ordineMenu[j].omil[z].scelta.nome + '\n', 'gh', 26)


      }


    }

    //stampa articoli
    var i;

    for (i = 0; i < this.ordineItems.length; i++) {
      if (this.ordineItems[i].articolo.codice != null && this.ordineItems[i].articolo.codice != "")

        await sunmiInnerPrinter.printTextWithFont("#" + this.ordineItems[i].quantita + "x" + this.ordineItems[i].articolo.codice + " " + this.ordineItems[i].articolo.name + '\n', 'gh', 26)
      else
        await sunmiInnerPrinter.printTextWithFont("#" + this.ordineItems[i].quantita + "x" + this.ordineItems[i].articolo.name + '\n', 'gh', 26)


    }
    await sunmiInnerPrinter.printTextWithFont('-------------------------\n', 'gh', 30)
    if (this.ordineItem.sconto > 0) {
      await sunmiInnerPrinter.setAlignment(2);// align right

      // await sunmiInnerPrinter.printTextWithFont('Costo consegna ', 'gh', 25)
      // await sunmiInnerPrinter.printTextWithFont('€ ' + this.ordineItem.consegna.toFixed(2) + '\n', 'gh', 26)

      await sunmiInnerPrinter.setFontSize(25)
      var colsWidthArr = [15, 16]; //16 non va a capo
      var colsTextArr: any[];
      colsTextArr = ['Sconto', '€ -' + this.ordineItem.sconto.toFixed(2)];
      var colsAlign = [0, 2];

      await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);

    }

    await sunmiInnerPrinter.setAlignment(2);// align right

    if (this.ordineItem.address != null) {
      // await sunmiInnerPrinter.printTextWithFont('Costo consegna ', 'gh', 25)
      // await sunmiInnerPrinter.printTextWithFont('€ ' + this.ordineItem.consegna.toFixed(2) + '\n', 'gh', 26)

      await sunmiInnerPrinter.setFontSize(25)
      var colsWidthArr = [15, 16];
      var colsTextArr: any[];
      colsTextArr = ['Costo consegna', '€ ' + this.ordineItem.consegna.toFixed(2)];
      var colsAlign = [0, 2];

      await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);

    }

    
    // await sunmiInnerPrinter.printTextWithFont('Totale ', 'gh', 30)
    //await sunmiInnerPrinter.printTextWithFont('€ ' + this.ordineItem.totale.toFixed(2) + '\n', 'gh', 30)

    await sunmiInnerPrinter.setFontSize(30)
    var colsWidthArr = [10, 16];
    var colsTextArr: any[];


    colsTextArr = ['Totale', '€ ' + this.ordineItem.totale.toFixed(2)];
    var colsAlign = [0, 2];


    await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);


   
    await sunmiInnerPrinter.setAlignment(0);// align left


    if (this.ordineItem.note != null) {
      await sunmiInnerPrinter.printTextWithFont("\nNote:" + this.ordineItem.note + '\n', 'gh', 30)

    }

    await sunmiInnerPrinter.printTextWithFont(" \n", 'gh', 22)



    // await sunmiInnerPrinter.printTextWithFont("Numero di telefono:\n", 'gh', 30);



    await sunmiInnerPrinter.setFontSize(30);
    //alert(JSON.stringify(this.ordineItem));
    if (this.ordineItem.address != null) {
      if (this.ordineItem.stato != 3) {
        //await sunmiInnerPrinter.printOriginalText('Consegna prev.:' + this.ordineItem.consegnaPrevisto);
        //  alert( this.ordineItem.consegnaPrevisto);
        if (this.ordineItem.consegnaPrevisto != null) {
          await sunmiInnerPrinter.setFontSize(30)
          var colsWidthArr = [17, 8];
          this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);
          var colsTextArr = ["Consegna prevista", this.ordineItem.consegnaPrevisto];
          var colsAlign = [0, 2];

          await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
        }
      }
      else {
        await sunmiInnerPrinter.setAlignment(1);
        await sunmiInnerPrinter.printOriginalText('Ordine annullato');
      }

    } else {
      if (this.ordineItem.stato != 3) {
        // await sunmiInnerPrinter.printOriginalText('Ritiro prev.:' + this.ordineItem.consegnaPrevisto);
        // alert( this.ordineItem.consegnaPrevisto);
        if (this.ordineItem.consegnaPrevisto != null) {

          await sunmiInnerPrinter.setFontSize(30)
          var colsWidthArr = [17, 8];
          this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);
          var colsTextArr = ["Ritiro previsto", this.ordineItem.consegnaPrevisto];
          var colsAlign = [0, 2];

          await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
        }
      }
      else {
        await sunmiInnerPrinter.setAlignment(1);

        await sunmiInnerPrinter.printOriginalText('Ordine annullato');

      }

    }
    await sunmiInnerPrinter.printTextWithFont(" \n", 'gh', 22)

    await sunmiInnerPrinter.printTextWithFont("Tel." + this.ordineItem.usercliente.username + '\n', 'gh', 35);
    await sunmiInnerPrinter.printOriginalText("\n");

    await sunmiInnerPrinter.printOriginalText("\n");
    await sunmiInnerPrinter.printOriginalText(" \n");




  }

}



// WEBPACK FOOTER //
// ./src/pages/viewordine/viewordine.ts